import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Highlight from "../components/Highlight";
import Footer from "../components/Footer";
import ScrollToTop from "../components/ScrollToTop";
import data from "../Data";

function Home() {
  const [showScroll, setShowScroll] = useState(false);
  const [showCatalogue, setShowCatalogue] = useState(true);

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 300) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 300) {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);
    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScroll]);

  return (
    <div>
      <Header />
      <Highlight />
      <Footer />
      {showScroll && <ScrollToTop />}
      {showCatalogue && (
        <div className="catalogueBadge">
          <a href={data.CatalogueUrl} target="_blank" rel="noopener noreferrer">
            <img src={`${data.CatalogueUrl}files/thumb/1.jpg`} alt="" />
            <span>
              <small>New catalogue</small>
              Light Beyond Silence
              <small>2006–2026 · Read online →</small>
            </span>
          </a>
          <button aria-label="Close" onClick={() => setShowCatalogue(false)}>×</button>
        </div>
      )}
    </div>
  );
}

export default Home;
